import React from 'react';
import { StyleSheet, View } from 'react-native';

import { useColors } from '../../hooks';

type KeyboardIndicatorProps = {
  children: React.ReactNode;
};

const KeyboardIndicator = ({ children }: KeyboardIndicatorProps) => {
  const colors = useColors();

  return (
    <View style={[styles.indicator, { borderColor: colors.borderColor }]}>
      {children}
    </View>
  );
};

export default KeyboardIndicator;

const styles = StyleSheet.create({
  indicator: {
    paddingVertical: 2,
    paddingHorizontal: 8,
    borderWidth: 1,
    borderBottomWidth: 3,
    borderRadius: 4,
    marginRight: 4,
  },
});
